/* unplugin-vue-components disabled */import script from "./PopupForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupForm.vue?vue&type=script&setup=true&lang=js"

import "./PopupForm.vue?vue&type=style&index=0&id=e0f87946&lang=less"

const __exports__ = script;

export default __exports__